import { LanguageLocalePair, LocaleCode } from '@language';

export interface EnvironmentConfig {
    readonly env: string;
    readonly buildVersion: string;

    // Main URLs
    readonly tenantUrl: string;
    readonly baseUrl: string;
    readonly apiUrl: string;

    // Navigational URLs
    readonly mh2Url: string;
    readonly managementAppUrl: string;
    readonly monitoringUrl: string;
    readonly importUrl: string;
    readonly extendedMediaPlayerUrl: string;
    readonly registrationUrl: string;
    readonly embedUrl: string;
    readonly permalinkBase: string;

    // Oauth 2.0 authentication
    readonly authenticationUrl: string;
    readonly authorizationUrl: string;
    readonly clientId: string;
    readonly clientSecret: string;
    readonly publicHostRedirect: boolean;
    readonly directOAuth: string;

    // Languages
    readonly supportedLocales: LanguageLocalePair[];
    readonly fallbackLanguage: LocaleCode;

    // API keys
    readonly googleApiKey: string;
}

export const defaultEnvironmentConfig: EnvironmentConfig = {
    env: 'production',
    buildVersion: '',
    tenantUrl: '',
    baseUrl: '',
    apiUrl: '',
    mh2Url: '',
    managementAppUrl: '',
    monitoringUrl: '',
    importUrl: '',
    extendedMediaPlayerUrl: '',
    registrationUrl: '',
    embedUrl: '',
    permalinkBase: '',
    authenticationUrl: '',
    authorizationUrl: '',
    clientId: '',
    clientSecret: '',
    publicHostRedirect: true,
    directOAuth: '',
    supportedLocales: [],
    fallbackLanguage: 'en_US' as LocaleCode,
    googleApiKey: ''
};
